import { render, staticRenderFns } from "./CustomerImportWelcome.vue?vue&type=template&id=7345bee0&scoped=true&"
import script from "./CustomerImportWelcome.vue?vue&type=script&lang=ts&"
export * from "./CustomerImportWelcome.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerImportWelcome.vue?vue&type=style&index=0&id=7345bee0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7345bee0",
  null
  
)

export default component.exports